/*
 * Copyright (c) 2025 - 2026. Bluemate B.V.
 */

import {useTranslation} from 'react-i18next';

import {NotificationProps} from './notificationsPage';

import {onShowConfirmSnackbar} from '../../util/renderUtil';

import Notification from '../../models/notificationModel';

type RetType = [(value: string) => void];

export default function useDefaultNotification(props: NotificationProps): RetType {
    const {t} = useTranslation();
    const {notification, onChangeNotification} = props;

    function onChangeEmailAddresses(value: string) {
        notification.emailAddresses = value.split(',');
        // Confirm the "Send email to" dialog with a green toast — but only once
        // the save actually succeeded (onSaved runs on the persist result).
        onChangeNotification(notification, (_notification: Notification, success: boolean) => {
            if (success)
                onShowConfirmSnackbar(t('notifications.components.emailSavedSnackbar', 'E-mailadres opgeslagen'));
        });
    }

    return [onChangeEmailAddresses];
}
